import { render, staticRenderFns } from "./SidebarToggle.vue?vue&type=template&id=cbe84f16&scoped=true"
import script from "./SidebarToggle.vue?vue&type=script&lang=js"
export * from "./SidebarToggle.vue?vue&type=script&lang=js"
import style0 from "./SidebarToggle.vue?vue&type=style&index=0&id=cbe84f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe84f16",
  null
  
)

export default component.exports